/*****************************************************************************/
/*  File Name: addUserDialog.js                                              */
/*  Date:      April 18 2022                                                 */
/*  Author:    Ben Wakutz                                                    */
/*  Purpose:   Dialog to allow for the adding of a user to a clinic          */
/*****************************************************************************/

import React, { useEffect, useState } from 'react';
import { getFunctions, httpsCallable } from 'firebase/functions';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import { Button } from '@mui/material';
import TextField from '@mui/material/TextField';
import * as ROLES from '../../constants/roles';
import LoadingBlock from '../Loading';
import styles from './styles/addUser.module.scss'



function AddUserDialog({ openDialog, setOpenDialog, clinic }) {
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [email, setEmail] = useState('');

  const [password, setPassword] = useState('');
  const [sanitizedMessage, setSanitizedMessage] = useState('');
  const [addingUserLoading, setAddingUserLoading] = useState(false);
  const [addUserSuccess, setAddUserSuccess] = useState(null)
  const functions = getFunctions();
  const addUserFromAdmin = httpsCallable(functions, 'users-addUserFromAdmin');



  const generatePassword = (length) => {
    const charSets = {
      uppercase: "ABCDEFGHIJKLMNOPQRSTUVWXYZ",
      lowercase: "abcdefghijklmnopqrstuvwxyz",
      numbers: "0123456789",
      symbols: "!@#$%^&*()_+-=[]{}<>/?",
    };

    let availableChars = "";
    availableChars += charSets.uppercase;
    availableChars += charSets.lowercase;
    availableChars += charSets.numbers;
    availableChars += charSets.symbols;

    if (!availableChars) return "";

    let password = "";
    for (let i = 0; i < length; i++) {
      const randomIndex = Math.floor(Math.random() * availableChars.length);
      password += availableChars[randomIndex];
    }

    return password;
  };



  const generatePass = () => {
    setPassword(
      generatePassword(12)
    );
  }

  const closeDialog = () => {
    setFirstName('');
    setLastName('');
    setEmail('');
    setPassword('');
    setSanitizedMessage('');
    setAddingUserLoading(false);
    setOpenDialog(false);
    setAddUserSuccess(null)
  };

  const addUser = () => {
    //collect all required data
    /*     console.log('First name -> ',firstName);
    console.log('Last Name --> ',lastName);
    console.log('Email ------> ',email);
    console.log('Role -------> ',role);
    console.log('Clinic ID --> ',clinicID);
    console.log('password ---> ', password); */
    //console.log('does initials work here ->', firstName[0] + ' '+ lastName[0] );
    let user = {};

    user = {
      firstName: firstName,
      lastName: lastName,
      fullName: firstName + ' ' + lastName,
      initials: firstName[0] + ' ' + lastName[0],
      email: email,
      role: ROLES.ADMIN,
      password: password,
      defaultPassword: true,
    };


    //console.log(collected);
    // call cloud function
    setAddingUserLoading(true);

    addUserFromAdmin({ user }).then((result) => {
      //console.log('this is my results---- > ', result)
      const resultData = result.data;
      setAddUserSuccess(result.data.success)

      if (resultData.success === false) {
        setSanitizedMessage(resultData.message.errorInfo.message);
      } else {
        setSanitizedMessage(resultData.message);
        setAddingUserLoading(false)
      }
      //console.log("message -> ", sanitizedMessage);
    });
  };

  let disable = true;

  disable = firstName === '' || lastName === '' || email === '' || password === '';

  //console.log("Clinic in add user",clinic);

  return (
    <Dialog open={openDialog} onClose={() => closeDialog()} fullWidth={true} maxWidth='sm'>
      <DialogTitle>
        <Grid item xs container>
          <Grid item xs={11}>
            <Typography variant='h6'>Add User{/* {t('admin.addUsers.addClinicUser')} */}</Typography>
          </Grid>
          <Grid item xs={1} align='right'>
            <IconButton onClick={() => closeDialog()}>
              <CloseIcon />
            </IconButton>
          </Grid>
        </Grid>
      </DialogTitle>
      <DialogContent dividers>
        <Grid item xs container spacing={2} alignItems='center' justify='center'>
          {/* Company auto select + unchangeable if sent from addClinic*/}
          {/* Leave empty Grid for other add user permutations*/}
          {!addingUserLoading ? (
            !addUserSuccess ? (
              <>
                <Grid item xs={12}>
                  <TextField required label='Email' name='email' value={email} id='email' onChange={(event) => setEmail(event.target.value)} className={styles.textField} />
                </Grid>
                <Grid item xs={12}>
                  <TextField required label='First Name' name='firstName' value={firstName} id='firstName' onChange={(event) => setFirstName(event.target.value)} className={styles.textField} />
                </Grid>
                <Grid item xs={12}>
                  <TextField required label='Last Name' name='lastName' value={lastName} id='lastName' onChange={(event) => setLastName(event.target.value)} className={styles.textField} />
                </Grid>
                <Grid item xs={12}>
                  <TextField required label='Password' name='password' value={password} id='password' onChange={(event) => setPassword(event.target.value)} className={styles.textField} />
                </Grid>
              </>
            ) : (
              <>
                <Grid item xs={12}>
                  <Typography variant='h6'>{sanitizedMessage}</Typography>
                </Grid>
                <Grid item xs={12} alignSelf={'center'}>
                  <Typography variant='p'>Password for user: {password}</Typography>
                </Grid>
              </>
            )


          ) : (
            <>

              <Grid item xs={6}>
                <LoadingBlock />
              </Grid>
              <Grid item xs={6}>
                Adding User
              </Grid>

            </>
          )}
        </Grid>
      </DialogContent>
      <DialogActions>
        <Grid item xs={4}>
          <Button onClick={() => closeDialog()}>Cancel</Button>
        </Grid>
        <Grid item xs={4}>
          <Button onClick={() => generatePass()}>Generate Password</Button>
        </Grid>
        <Grid item xs={4} align='right'>
          {!addingUserLoading ? (
            <Button color='primary' disabled={disable} onClick={() => addUser()}>
              Add User
            </Button>
          ) : null}
        </Grid>
      </DialogActions>
    </Dialog>
  );
}

export default AddUserDialog;
